import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_CHECK, AUTH_ERROR, AUTH_GET_PERMISSIONS, fetchUtils } from 'react-admin';
import jwtDecode from 'jwt-decode';

export default (options = {}) => (type, params) => {
  const TOKEN_DATE = 'tokenDate';
  let { apiUrl, storageKey, client } = { ...{ client: fetchUtils.fetchJson, storageKey: 'user' }, ...options };
  if (apiUrl.endsWith('/')) {
    apiUrl = apiUrl.substr(0, apiUrl.length - 1);
  }

  const host = apiUrl + '/users/login';
  switch (type) {
    case AUTH_LOGIN:
      const { username, password } = params;
      const options = {
        method: 'POST',
        body: JSON.stringify({ username, password }),
      };

      return client(host, options).then(response => {
        localStorage.setItem(storageKey, response.body);
        localStorage.setItem(TOKEN_DATE, +new Date());
      });

    case AUTH_LOGOUT:
      localStorage.removeItem(storageKey);
      return Promise.resolve();

    case AUTH_CHECK:
      let user = localStorage.getItem(storageKey);
      if (user) {
        user = JSON.parse(user);
        const jwt = jwtDecode(user.token);
        const tokenDate = localStorage.getItem(TOKEN_DATE);
        const diff = (new Date() - tokenDate) / 1000;

        // refresh token of half of the exp time is passed
        if ((jwt.exp - jwt.iat) / 2 < diff) {
          const refreshOptions = {
            method: 'POST',
            user: {
              authenticated: true,
              token: 'Bearer ' + user.token,
            },
          };

          client(apiUrl + '/users/refresh', refreshOptions).then(response => {
            localStorage.setItem(storageKey, response.body);
            localStorage.setItem(TOKEN_DATE, +new Date());
          });
        }
        return Promise.resolve();
      }

      return Promise.reject();

    case AUTH_ERROR:
      const { status } = params;
      if (status === 401 || status === 403) {
        localStorage.removeItem(storageKey);
        return Promise.reject();
      }
      return Promise.resolve();

    case AUTH_GET_PERMISSIONS:
      const item = JSON.parse(localStorage.getItem(storageKey));

      if (!item) {
        return Promise.reject();
      }

      if (item.roles && item.roles.length > 0) {
        return Promise.resolve(item.roles[0]);
      }
      return Promise.resolve('');

    default:
      throw new Error(`Unsupported authClient action type ${type}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/authClient.js